
<template>
  <div class="gallery-outer">
      <div ref="slider" class="gallery" :style=" { 'height': galleryHeight + 'px' } ">
        <div class="gallery-inner" @touchstart="startSwipe" @touchmove="moveSwipe" @touchend="endSwipe">
          <div class="gallery-image-holder" :style=" { 'width': myimage.mywidth + 'px', 'height': myimage.myheight + 'px' } ">
            <div class="gallery-image-inner" :class=" { 'active': myimage.imageReady } " :style=" { 'background-image':  'url(static/img/content/' + myimage.img + ')' } "></div>
              <label v-if="myimage.label" :class=" { 'active': myimage.imageReady } "> {{ myimage.label }} </label>
          </div>
        </div>

        <button v-show="array.length > 1" class="arrow-button arrow-left" @click="clickArrow(-1)">
          <i class="fas fa-chevron-left"></i>
        </button>
        <button v-show="array.length > 1" class="arrow-button arrow-right" @click="clickArrow(1)">
          <i class="fas fa-chevron-right"></i>
        </button>
      </div>
    </div>
</template>

<script>
import {commontools} from '../mixins/Styling'

export default {
  props: ['array', 'hasVideoBoxes'],
  mixins: [commontools],
  data: function () {
    return {
      myimage: {
        array: [],
        img: null,
        label: 'Hello',
        mywidth: 500,
        myheight: 500,
        counter: 0,
        imageReady: false
      },
      galleryPercent: 0.8,
      galleryHeight: window.innerHeight - 140,
      myimages: [],
      clickindex: 0,
      startx: 0,
      arrowGap: 0
    }
  },
  methods: {
    getImages () {

      this.loadCounter = this.myimages.array.length

      this.myimages.array.map(image => {
        this.preloadImages('static/img/content/'+image.img).then(myimg => {
          let ar = myimg.naturalWidth / myimg.naturalHeight

          Vue.set(image, 'ar', ar)

          this.loadCounter--
          if (this.loadCounter === 0) {
            this.isReady = true
            this.resizeGallery()
            this.showNextImage()
          }
        })
      })

    },
    resizeGallery () {
      let maxh;
      if (window.innerWidth >= 768) {
        maxh = window.innerHeight - 140 - this.arrowGap
      } else {
        maxh = window.innerHeight - 140 - this.arrowGap
      }
     // let maxh = window.innerHeight * this.galleryPercent
      this.galleryHeight = 0

      this.myimages.array.map((image) => {

        let imageh = document.body.clientWidth / image.ar

        if (imageh > maxh) {
          this.galleryHeight = maxh
          return true
        }
        if (this.galleryHeight < imageh) this.galleryHeight = imageh
      })
    },
    handleResize () {
      this.resizeGallery()
      this.showNextImage()
    },
    showNextImage () {

      let maxw = document.body.clientWidth
      let maxh = window.innerHeight - 140 - this.arrowGap

      let imgdata = this.myimages.array[this.myimage.counter]
      this.myimage.img = imgdata.img
      this.myimage.label = imgdata.label
      if (maxh * imgdata.ar > maxw) {
        this.myimage.mywidth = maxw
        this.myimage.myheight = Math.round(maxw / imgdata.ar)
      } else {
        this.myimage.mywidth = Math.round(imgdata.ar * maxh)
        this.myimage.myheight = maxh
      }
      setTimeout(() => {
        this.myimage.imageReady = true
      }, 300)
    },
    clickArrow (_val) {
      this.myimage.imageReady = false

      let val = _val

      setTimeout(() => {
        this.myimage.counter += val
        if (this.myimage.counter >= this.myimages.array.length) this.myimage.counter = 0
        if (this.myimage.counter < 0) this.myimage.counter = this.myimages.array.length - 1
        this.showNextImage()
      },300)
    },
    startSwipe: function (evt) {
      this.startx = evt.changedTouches[0].clientX
    },
    moveSwipe: function (evt) {
      // evt.preventDefault()
    },
    endSwipe: function (evt) {
      let endx = evt.changedTouches[0].clientX
      if (this.startx > endx + 75) this.clickArrow(-1)
      if (this.startx < endx - 75) this.clickArrow(1)
    },
    handler: function () {
      this.myimages = this.array
      this.myimages.map((c, i) => {
        Vue.set(c, 'position', i - 2)
      })
    }
  },
  mounted: function () {
    this.myimages.array = this.array
    if (this.hasVideoBoxes !== undefined) this.arrowGap = 40
    this.getImages()
  },
  created () {
    window.addEventListener('resize', this.handleResize)
  },
  destroyed () {
    window.removeEventListener('resize', this.handleResize)
  },
  computed: {
    // a computed getter
  },
  components: {
  }
}
</script>

<style>
@import '../../static/css/vars.css';

.video-project-gallery {
  margin-top: 30px;
}
.video-project-gallery .name-section {
  margin-bottom: 20px;
}
.gallery {
  width:100%;
  position: relative;
  margin-bottom: 50px;
}
.gallery-image-holder {
  transition: 0.3s ease-out;
  -webkit-transition: 0.3s ease-out;
  position: relative;
  left:50%;
  top:50%;
  transform: translate3d(-50%, -50%, 0);
  transform-origin: 50% 50%;
  -webkit-transform: translate3d(-50%, -50%, 0);
  -webkit-transform-origin: 50% 50%;
  background-color: rgba(0,0,0,0.1);
}
.gallery-image-inner {
  position: relative;
  width:100%;
  height: 100%;
  background-size: cover;
  transition: 0.3s ease-out;
  -webkit-transition: 0.3s ease-out;
  opacity: 0;
}
.gallery-outer label {
  transition: 0.3s ease-out;
  -webkit-transition: 0.3s ease-out;
  position: relative;
  opacity: 0;
  font-size: 16px;
  margin: 10px 0 0;
  width: 100%;
  text-align: center;
}
.gallery-outer label.active,
.gallery-image-inner.active {
  opacity: 1;
}
.gallery-outer button {
  border: 0;;
}
.gallery-inner {
  position: relative;
  width: 100%;
  left:0;
  height:100%;
  overflow: visible;
}
.arrow-button {
  position: absolute;
  z-index: 2;
  width: 34px;
  height: 34px;
  cursor: pointer;
  box-sizing: border-box;
  top:50%;
  background-color: rgba(255,255,255,0.3);
  transition: 0.2s ease-out;
  -webkit-transition: 0.2s ease-out;
  font-size: 24px;
  line-height: 34px;
  color: #000;
  text-align: center;
}
.arrow-left {
  left: 10px;
  transform: translate3d(0px, -50%, 0);
  -webkit-transform: translate3d(0px, -50%, 0); 
}
.arrow-left i {
  animation: arrowBounceLeft 1s infinite;
  -webkit-animation: arrowBounceLeft 1s infinite;
  animation-timing-function: ease-in-out;
  -webkit-animation-timing-function: ease-in-out;
}
.arrow-right {
  right:10px;
  transform: translate3d(-0px, -50%, 0);
  -webkit-transform: translate3d(-0px, -50%, 0);
}
.arrow-right i {
  animation: arrowBounceRight 1s infinite;
  -webkit-animation: arrowBounceRight 1s infinite;
  animation-timing-function: ease-in-out;
  -webkit-animation-timing-function: ease-in-out;
}
.arrow-left i, .arrow-right i {
    line-height: 34px;
  }
.no-touch-device .arrow-button:hover {
  background-color: var(--main-color);
  color: #fff;
}
.arrow-button:active {
  background-color: var(--main-color);
  -webkit-transition: 0.1s ease-out;
  transition: 0.1s ease-out;
  opacity: 0.8;
  -webkit-transform: scale3d(0.95,0.95, 0.95) translate3d(0px, -50%, 0);
  -ms-transform: scale3d(0.95,0.95, 0.95) translate3d(0px, -50%, 0);
  -moz-transform: scale3d(0.95,0.95, 0.95) translate3d(0px, -50%, 0);
  transform: scale3d(0.95,0.95, 0.95) translate3d(0px, -50%, 0);
}

@media (min-width: 768px) {
  .arrow-button {
    width: 40px;
    height: 40px;
    font-size: 30px;
  }
  .arrow-button-svg {
    width: 36px;
    height:32px;
  }

  .arrow-left i, .arrow-right i {
    line-height: 40px;
  }
  .gallery-inner {
    background-color: transparent;
  }
}
@media (min-width: 992px) {

}
  @keyframes arrowBounceLeft {
    0% {transform: translate3d(0px, 0%, 0);} 
    40% {transform: translate3d(-3px, 0%, 0);} 
    100% {transform: translate3d(0px, 0%, 0);} 
  }
  @-webkit-keyframes arrowBounceLeft {
    0% {-webkit-transform: translate3d(0px, 0%, 0);} 
    40% {-webkit-transform: translate3d(-3px, 0%, 0);} 
    100% {-webkit-transform: translate3d(0px, 0%, 0);} 
  }
  @keyframes arrowBounceRight {
    0% {transform: translate3d(0px, 0%, 0);} 
    40% {transform: translate3d(3px, 0%, 0);} 
    100% {transform: translate3d(0px, 0%, 0);} 
  }
  @-webkit-keyframes arrowBounceRight {
    0% {-webkit-transform: translate3d(0px, 0%, 0);} 
    40% {-webkit-transform: translate3d(3px, 0%, 0);} 
    100% {-webkit-transform: translate3d(0px, 0%, 0);} 
  }

@media (min-width: 768px) {
  .arrow-left {
    transform: translate3d(0px, -50%, 0);
    -webkit-transform: translate3d(0px, -50%, 0);
    
  }
  .arrow-right {
    transform: translate3d(-0px, -50%, 0);
    -webkit-transform: translate3d(-0px, -50%, 0);
  }
}
</style>